/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { PieChart, Pie, Tooltip, Cell, ResponsiveContainer } from 'recharts';
import MiniLoader from '../../common/components/MiniLoader';

const PieComponentV2 = ({ chartData, services }) => {
  const data = chartData;
  // todo: map chartData doesn't seem to have much use in here, try to replace this with services (all data rendered from pie chart are from services)


  const COLORS = [
    '#A3B3F9', // BPLS
    '#B1CDF8', // BTAX
    '#BBE9FE', // CDL
    '#5272AA', // CRIS
    '#84DAFF', // MMS
    '#8AA4F8', // MVOPS
    '#D9F5FA', // OHP
    '#8EEED7', // PSA
    '#7790CB', // RPTS
    '#99BBFF', // SCMS
  ];

  return (
    <ResponsiveContainer height={200} width="100%">
      {data.length === 0 ? (
        <MiniLoader />
      ) : (
        <PieChart>
          <Pie
            // data={data}
            data={services}
            innerRadius={65}
            outerRadius={80}
            dataKey="value"
          >
            {/* {data.map((_entry, index) => ( // ex. { name: 'BPLS', value: 0 }
              <Cell
                key={`cell-${index}`}
                // fill={COLORS[index % COLORS.length]}
                fill={COLORS[index % COLORS.length]}
              />
            ))} */}
            {services.map((entry, index) => {      
              return <Cell
              key={`cell-${index}`}
              fill={entry.color}
            />
            })}
          </Pie>
          {/* {services.map((entry, index) => {
            return <Tooltip />
          })} */}
          <Tooltip active={false} />
        </PieChart>
      )}
    </ResponsiveContainer>
  );
};

PieComponentV2.propTypes = {
  chartData: PropTypes.instanceOf(Array).isRequired,
  services: PropTypes.instanceOf(Array).isRequired,
};

export default PieComponentV2;
